import {
    GRID_BREAKPOINT_PX,
    GRID_GUTTER_PX,
    GRID_ROW_HEIGHT_PX,
} from "./layoutConfig";

/**
 * The names other modules use to find the grid's parts. The grid's units and
 * every other tunable value are in `layoutConfig.ts`.
 */

export const LAYOUT_SCHEMA_VERSION = 1 as const;

/** Matches viewports wide enough for the arrangeable grid. */
export const GRID_ARRANGE_MEDIA_QUERY = `(min-width:${GRID_BREAKPOINT_PX}px)`;

/**
 * The corner radius every card root passes to `borderRadius`, in theme units
 * (eight pixels). Overlays drawn on a card use it too, so they share the card's
 * corners. In `sx` a bare number is multiplied by the theme radius, which is why
 * this is the theme unit rather than pixels.
 */
export const CARD_RADIUS = 2 as const;

/** The grip a card is dragged by. */
export const DRAG_HANDLE_CLASS = "signals-layout-drag-handle";

/** The outline that follows the pointer during a resize. */
export const RESIZE_OUTLINE_CLASS = "signals-resize-outline";

/**
 * Marks the element inside a content-driven card whose children are the
 * card's content. Needed only by cards whose content sits in one panel that
 * fills the card, because that panel's own height is the grid's, not the
 * content's. Other cards are measured from their root.
 */
export const CARD_CONTENT_ATTRIBUTE = "data-acx-card-content" as const;

/** The whole rows needed to hold a measured pixel height. */
export function pixelsToGridRows(pixels: number): number {
    if (!Number.isFinite(pixels) || pixels <= 0) return 0;
    return Math.ceil((pixels + GRID_GUTTER_PX * 2) / GRID_ROW_HEIGHT_PX);
}
